export const team = () =>
  import(
    /* webpackChunkName: "editor3Presets-team" */ './definitions/team.json'
  )

export const dev = () =>
  import(/* webpackChunkName: "editor3Presets-dev" */ './definitions/dev.json')
